export { default as FundList } from "./FundList"
